import { defineComponent as _defineComponent } from 'vue'
import { PropType } from 'vue';
import { GenericOption } from '../../../../../types/components';
import DropdownSelector from '../DropdownSelector.vue';
import Icon from '../icons.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SpreadSelector',
  props: {
  spreadOptions: {
    type: Array as PropType<GenericOption[]>,
    required: true
  },
  selectedSpread: {
    type: Object as PropType<GenericOption>,
    required: true
  },
  isCentered: {
    type: Boolean,
    default: true
  },
  showAsList: {
    type: Boolean,
    default: false
  }
},
  emits: ['spread-change'],
  setup(__props, { emit }) {

const props = __props;



function removeParentheses(value: string): string {
  if (!value) return '';
  return value.replace(/\([^)]*\)/g, '');
}



return { __sfc: true,props, removeParentheses, emit, DropdownSelector, Icon }
}

})